import React from 'react';
import ReactDOM from 'react-dom/client';
import reactAxe from '@axe-core/react';
import { LicenseInfo } from '@mui/x-license-pro';
import LogRocket from 'logrocket';
import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import 'overlayscrollbars/styles/overlayscrollbars.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import worker from './mocks/browser';
import { ENVIRONMENT_KEY } from './localStorageKeys';

if ( localStorage.getItem(ENVIRONMENT_KEY) === 'production') {
  LogRocket.init(process.env.REACT_APP_LOGROCKET_APP_ID,{
    rootHostname: process.env.REACT_APP_LOGROCKET_ROOT_HOSTNAME,
  });
}

if (process.env.REACT_APP_MSW_ENABLED === 'true') {
  worker.start();
}

if (process.env.REACT_APP_AXE_ENABLED === 'true') {
  reactAxe(React, ReactDOM, 1000);
}

if (
  process.env.REACT_APP_SENTRY_ENABLED === 'true' &&
  localStorage.getItem(ENVIRONMENT_KEY) !== 'localhost'
) {
  Sentry.init({
    environment: localStorage.getItem(ENVIRONMENT_KEY),
    dsn: 'https://c8316e3a185c42278a78ce3e390bd298@sentry.eposnow.io/1223',
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.browserProfilingIntegration(),
    ],
    tracesSampleRate: 1.0,
    autoSessionTracking: true,
    profilesSampleRate: 0.25,
    release: `onboardingwizard@${process.env.REACT_APP_BUILD_VERSION}`,
  });
}

if (process.env.REACT_APP_MATERIAL_UI_LICENSE) {
  LicenseInfo.setLicenseKey(process.env.REACT_APP_MATERIAL_UI_LICENSE);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
